

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const updatePaymentApi = createAsyncThunk("updatePayment", async ({
    username,
    month,
    year,
}) => {
    const response = await axiosInstance.post("/updateCommissionPaid",
        {
            username,
            month,
            year,
        }
    );
    return response.data;
});

const updatePaymentSlice = createSlice({
    name: "updatePayment",
    initialState: {
        updatePayment: [],
        errors: [],
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updatePaymentApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(updatePaymentApi.fulfilled, (state, action) => {
                state.updatePayment = action?.payload;
                state.loading = false;
            })
            .addCase(updatePaymentApi.rejected, (state, action) => {
                state.errors = action.payload;
                // state.errors.push(action.error.message);
                state.loading = false;
            });
    },
});

export default updatePaymentSlice.reducer;
